<template>
  <div>
    <div class="qa-block" v-for="(item, index) in msgList" :key="index">
      <div class="question-section" v-if="item.is_from_self">
        <div class="question-content" style="max-width: 900px">
          {{ item.content }}
        </div>
      </div>
      <div class="loading" v-if="msgList.length % 2 == 1 && item.is_final && index == (msgList.length-1)">
        思考中
      </div>
      <div
        class="answer-section"
        v-if="!item.is_from_self"
        style="margin-top: 0px; padding: 0 0.5rem"
      >
        <div class="hyyueyue">
          <svg-icon
            class="hyAiYyIcon"
            style="width: 35px; height: 35px"
            icon-class="hyAiYY"
          ></svg-icon>
        </div>
        <div class="answer-card-content">
          <span class="hyAiYyWord">
            <svg-icon
              class="hyAiYyIcon"
              style="width: 30px; height: 30px"
              icon-class="hyAiYY"
            >
            </svg-icon>
            <span style="margin-left: 5px">悦悦：</span>
          </span>
          <div class="answer-card">
            <div class="answer-content">
              <div class="sc-gLDzan diOrVY">
                <div class="markdown-body">
                  <MsgContent
                    :showTags="true"
                    :recordId="item.record_id"
                    :isReplaceLinks="true"
                    :loadingMessage="item.loading_message"
                    :content="item.content"
                    :isFinal="item.is_final"
                    :isMdExpand="item.isMdExpand"
                    @littleTagClick="littleTagClick"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list-item-opera" style="align-items: center;padding-bottom: 8px;border-bottom: 1px solid #eee;margin-bottom: 8px;">
            <div
              class="opera-again"
              title="删除"
              @click="del(item)"
              style="display: flex; align-items: center; margin-right: 8px"
            >
              <van-icon name="delete-o" size="20" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clone from "clone";
import { Dialog, Toast } from "vant";
import { deleteAiChatDetail } from "@/api/wx.js";
export default {
  name: "ClientChat",

  data() {
    return {
      popperList: [],
      oldPopDemo: null,
      loading: false,
      historyLoading: false,
      timestampGap: 5 * 60, // 两次问题间隔大于5min，则展示时间戳（接口侧返回的时间戳是秒级）
      msgList: [], // 对话消息列表
      robotName: "", // 机器人名称
      chatBoxHeight: document.body.clientHeight,
      jsScrolling: false,
      userScrolling: false,
      isHISTORY: false,
      historyList: [],
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    copyData(item) {
      if (item.content) {
        this.copyToClip(item.content).then(() => {
          Toast("复制成功");
        });
      }
    },
    del(item) {
      const userInfo = localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {};
      Dialog.confirm({
        title: "系统提示",
        message: "你确定要删除吗？",
      }).then(() => {
        deleteAiChatDetail({
          username: userInfo.username,
          id: item.record_id,
        }).then((res) => {
          for (let i = this.msgList.length - 1; i >= 0; i--) {
            if (this.msgList[i].record_id == item.record_id) {
              this.msgList.splice(i, 1);
            }
          }
          if (this.msgList.length == 0) {
            this.$router.replace({ path: "/hyAichat" });
          }
        });
      });
    },
    openSearchUrl(refer, index) {
      window.open(refer.url);
    },
    // 监听用户端/管理端体验侧的ws事件
    listenClientAndManageEvent() {
      // 从缓存获取机器人信息
      this.robotName = "不重要";
    },
    copyToClip(text) {
      return new Promise((resolve, reject) => {
        try {
          const input = document.createElement("textarea");
          input.setAttribute("readonly", "readonly");
          input.value = text;
          document.body.appendChild(input);
          input.select();
          if (document.execCommand("copy")) document.execCommand("copy");
          document.body.removeChild(input);
          resolve(text);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 监听公共的ws事件
    listenCommonEvent() {},
    // 渲染消息会话页面
    renderMsgList(data, type) {
      // 无需滚动至底部的ws事件：用户端拉取历史记录、用户端停止生成、坐席端取历史记录、点赞点踩
      const list = data.map((el) => {
        return { ...el, showPop: true };
      });
      this.msgList = clone(list);
    },
    handleOutsideClick(event) {
      if (!this.oldPopDemo) {
        return;
      }
      const firstElement = document.getElementsByClassName("pop-demo")[0];
      if (
        this.oldPopDemo.contains(event.target) ||
        firstElement.contains(event.target)
      ) {
      } else {
        if (this.oldPopDemo) {
          this.$refs["first"] &&
            this.$refs["first"].unbindTrigger(this.oldPopDemo);
        }
        // 调用你想要执行的方法
        this.$refs["first"] && this.$refs["first"].hide();
        this.oldPopDemo = null;
      }
    },
    littleTagClick(e, r) {
      console.log(e, r, "kjhfkwhfejhfehfj");
    },
  },
};
</script>

<style lang="less">
.del-user-content {
  margin-left: 6px;
  cursor: pointer;
  text-decoration: underline;
  color: #1ee91e;
}
.diOrVY .markdown-body {
  text-size-adjust: 100%;
  margin: 0px;
  color: rgb(36, 41, 47);
  background-color: rgb(255, 255, 255);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans",
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 30px;
  line-height: 1.5;
  overflow-wrap: break-word;
  * {
    user-select: text !important;
  }
}
.diOrVY .markdown-body::after {
  display: table;
  clear: both;
  content: "";
}
</style>
<style lang="less" scoped>
.answer-section,
.qa-block {
  width: 100%;
}
.answer-section {
  display: flex;
}
.hyyueyue {
  min-width: 70px !important;
  display: none;
}
.hyAiYyWord {
  font-size: 28px !important;
  color: #666;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.question-section {
  padding: 0px 0.5rem;
  width: 100%;
  display: flex;
  justify-content: right;
}
.question-content {
  align-items: center;
  padding: 16px 20px;
  border-radius: 16px;
  display: flex;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-size: 30px;
  font-weight: 500;
  justify-content: center;
  line-height: 48px;
  word-break: break-all;
  user-select: text !important;
  background: #fff;
  color: #000;
  max-width: 80% !important;
  text-align: justify;
  // box-shadow: 0 0 0.13333rem 0 rgba(0, 0, 0, 0.1);
  // background: rgb(233, 233, 233);
}
.answer-card-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin: 0 auto;
  // max-width: calc(100% - 70px) !important;
  max-width: 100% !important;
  padding-top: 8px !important;
  // padding-left: 12px !important;
}
.answer-card {
  background: #fff;
  border: 1px solid #e8e9eb;
  border-radius: 16px;
  display: flex;

  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 16px 16px 12px;
  // box-shadow: 0 0 0.13333rem 0 rgba(0, 0, 0, 0.1);
  .answer-content {
    color: #333;
    flex-grow: 1;
    font-size: 30px;
    line-height: 1.6;
    margin-bottom: 16px;
  }
}
.list-item-opera {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
  width: 100%;
  justify-content: right;
}
.list-item-opera .opera-copy {
  cursor: pointer;
  display: flex;
  height: 20px;
  margin-right: 8px;
  position: relative;
  width: 20px;
}
.list-item-opera .opera-again {
  color: #84868c;
  cursor: pointer;
  // height: 20px;
  white-space: nowrap;
  // width: 20px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.loading {
  margin: 1em 0;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 30px;
  color: #333;
  padding: 0 0.5rem;
  &::after {
    content: ".";
    animation: ellipsis 1.5s steps(1, end) infinite;
  }
  &::before {
    content: "";
    display: inline-block;
    height: 44px;
    width: 44px;
    margin-right: 8px;
    background: url("~@/assets/img/ai-loading.gif") no-repeat;
    background-size: contain;
    border-radius: 44px;
    overflow: hidden;
  }
}
</style>
